// extracted by mini-css-extract-plugin
module.exports = {"item":"NavItem_item__W-vk_","link":"NavItem_link__2vjWq"};